export default __webpack_public_path__ + "static/media/succeeded.6b02a169.svg";